import { render, staticRenderFns } from "./bodySpeed.vue?vue&type=template&id=4a50cca2&scoped=true"
import script from "./bodySpeed.vue?vue&type=script&lang=js"
export * from "./bodySpeed.vue?vue&type=script&lang=js"
import style0 from "./bodySpeed.vue?vue&type=style&index=0&id=4a50cca2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50cca2",
  null
  
)

export default component.exports